import { createSlice } from "@reduxjs/toolkit";

export const dealer = createSlice({
  name: "dealer",
  initialState: {
    partnerOption: undefined as number | undefined,
  },
  reducers: {
    setPartnerOption: (state, { payload }) => {
      state.partnerOption = payload;
    },
  },
});

export const { setPartnerOption } = dealer.actions;

export const dealerReducer = dealer.reducer;